const characterState = {
  name: '',
  class: '',
  level: 1,
  xp: 0,
  alignment: '22',
  look: {
    body: '',
    eyes: '',
    hair: '',
    clothes: '',
  },
  bonds: [''],
  race: { title: '', description: ''},
  skills: [
    { name: 'Strength', abreviation: 'STR', score: 0 },
    { name: 'Dexterity', abreviation: 'DEX', score: 0 },
    { name: 'Constitution', abreviation: 'CON', score: 0 },
    { name: 'Inteligence', abreviation: 'INT', score: 0 },
    { name: 'Wisdom', abreviation: 'WIS', score: 0 },
    { name: 'Charisma', abreviation: 'CHA', score: 0 },
  ],
  armor: 0,
  hp: { max: 10, current: 10 },
  damage: '', 
  moves: {
    basic: [],
    special: [],
    starting: [],
    advanced: [],
    expert: []
  },
  spells: {},
  coin: 0,
  maxWeight: 0,
  weight: 0,
  inventory: [],
  notes: []

}

export default characterState;